import React from 'react';

import { Table } from '@devexpress/dx-react-grid-material-ui';
import ActionCell from './ActionCell';
import SensorSourcingCell from './SensorSourcingCell';

import defaultClasses from './SensorsTable.module.css';

function CellRenderer(cellProps) {
    let Component;

    switch (cellProps.column.name) {
        case 'action':
            Component = ActionCell;
            break;
        case 'sourcing':
            Component = SensorSourcingCell;
            break;
        default:
            Component = Table.Cell;
    }

    return <Component {...cellProps} className={defaultClasses.cell} />;
}

export default CellRenderer;
